import styles from "./admin-breadcrumbs.module.css";
import { UIIconName } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-type";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { usePaths } from "BEDROCK/paths";
export interface BreadcrumbItem {
  label: string;
  path?: string;
  iconName?: UIIconName;
}

interface AdminBreadcrumbsProps {
  items: BreadcrumbItem[];
  onClick?: (item: BreadcrumbItem) => void;
}
export const AdminBreadcrumbs = ({ items, onClick }: AdminBreadcrumbsProps) => {
  const { navigateTo } = usePaths();

  const handleClick = (item: BreadcrumbItem) => {
    if (item.path) {
      navigateTo(item.path);
    }
    if (onClick) {
      onClick(item);
    }
  };

  return (
    <div className={styles.container}>
      {items.map((item, index) => (
        <div
          key={index}
          className={styles.item}
          onClick={() => handleClick(item)}
        >
          {item.iconName && (
            <UIIcon iconName={item.iconName} variant="REGULAR" size={16} />
          )}
          <span className="item">{item.label}</span>
          {index < items.length - 1 && (
            <UIIcon iconName="CHEVRON-RIGHT" variant="REGULAR" size={16} />
          )}
        </div>
      ))}
    </div>
  );
};
